import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'underscore';

import { CommandBarButton } from '@fluentui/react/lib/Button';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  cellContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconButton: {
    padding: '10px 8px',
  },
  itemContentContainer: {
    margin: '16px 12px 16px 21px',
  },
  divider: {
    borderTop: '1px solid #EDEBEA',
    marginBottom: 8,
  },
  actionButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0px 12px 8px 10px',
  },
});

export function UnStyledToolCell({
  className,
  classes,
  item,
  ItemComponent,
  onDelete,
  onEdit,
  index,
  i18n,
  renderItemHeader,
  selectedPageIndex,
  numberOfItemsPerPage,
  deleteButtonAriaLabel,
  editButtonAriaLabel,
  editButtonLabel,
  editable,
}) {
  return (
    <div className={classnames(classes.cellContainer, className)} >
      {renderItemHeader && renderItemHeader(item.createdTime)}
      <div className={classes.itemContentContainer}>
        <ItemComponent
          item={item}
          i18n={i18n}
        />
      </div>
      <div className={classes.divider} />
      <div className={classes.actionButtonContainer} key={item.id}>
        {
          editable &&
          <CommandBarButton
            iconProps={{ iconName: 'Edit' }}
            text={editButtonLabel || i18n.getString(_TL_('Edit post'))} // TODO string check
            onClick={() => onEdit((selectedPageIndex * numberOfItemsPerPage) + index)}
            className={classnames('smart-page-edit-cell-icon', classes.iconButton)}
            ariaLabel={editButtonAriaLabel || i18n.getString(_TL_('Edit post'))}
          />
        }
        <CommandBarButton
          iconProps={{ iconName: 'Delete' }}
          text={i18n.getString(_TL_('Delete'))}
          onClick={() => onDelete((selectedPageIndex * numberOfItemsPerPage) + index)}
          className={classnames('smart-page-delete-cell-icon', classes.iconButton)}
          ariaLabel={deleteButtonAriaLabel || i18n.getString(_TL_('Delete'))}
        />
      </div>
    </div>
  );
}

UnStyledToolCell.propTypes = {
  classes: PropTypes.shape({
    cellContainer: PropTypes.string.isRequired,
  }).isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  ItemComponent: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func,
  index: PropTypes.number.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  renderItemHeader: PropTypes.func,
  className: PropTypes.string.isRequired,
  selectedPageIndex: PropTypes.number.isRequired,
  numberOfItemsPerPage: PropTypes.number.isRequired,
  deleteButtonAriaLabel: PropTypes.string,
  editButtonAriaLabel: PropTypes.string,
  editButtonLabel: PropTypes.string,
  editable: PropTypes.bool,
};

UnStyledToolCell.defaultProps = {
  renderItemHeader: null,
  deleteButtonAriaLabel: null,
  editButtonAriaLabel: null,
  onEdit: _.noop,
  editable: false,
  editButtonLabel: null,
};

export const ToolCell = withDefaultStyles(
  UnStyledToolCell,
  getStyles
);
